export default {
      id: "icon-x-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#icon-x",
      toString: function () {
        return this.url;
      }
    }